export default "__VITE_ASSET__WlXNngmM__"